/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/320-arrow-down-left2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.293 2.293L4 10.586V7a1 1 0 00-2 0v6a1.002 1.002 0 001 1v.001h6a1 1 0 000-2H5.414l8.293-8.293a.997.997 0 000-1.414.999.999 0 00-1.414 0z"/>'
  }
})
